<template>
    <div v-show="visible">
        <el-dialog title="新增日期" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">          
                <el-form-item prop="startDate" label="开始日期">
                    <el-date-picker
                        v-model="form.startDate"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>

                <el-form-item prop="endDate" label="结束日期">
                    <el-date-picker
                        v-model="form.endDate"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                isAuto:false,
                transferVisible:false,
                props: { checkStrictly: true},
                form:{
                    startDate:"",
                    endDate:""
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                rules: {
                    startDate: [
                        { required: true, message: '请选择开始日期', trigger: 'blur' }
                    ],
                    endDate: [
                        { required: true, message: '请选择结束日期', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let data = {
                            startDate:this.form.startDate,
                            endDate:this.form.endDate
                        };
                        // console.log(JSON.stringify(data));
                        this.$parent.addDate(data);
                        this.visible=false;
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/gate/AddDate.vue